import MultiRowInput from './multi.row.input';

export default MultiRowInput;
